interface IC {
  list: string[];
}
export const mockConfig: IC = {
  list: [
    // '/hermes/activity/getInfo',
    // '/hermes/operateReport/getDeptAndGameMap',
    // '/hermes/operateReport/getServiceTypes',
    // '/hermes/operateReport/getServiceProduct',
    // '/hermes/operateReport/getInterfaceAccess',
    // '/hermes/operateReport/getOperatingActivity',
    // '/hermes/operateReport/getBusiness',
    // '/hermes/operateReport/getGameData'
    // '/hermes/reportConfig/getReportList',
    // '/hermes/reportConfig/getSummaryData',
    // '/hermes/reportConfig/getBigCategory',
    // '/hermes/reportConfig/getSummaryTable'
    // '/hermes/reportConfig/getSmallCategoryChart',
    // '/hermes/reportConfig/getSmallCategoryConfig',
    // '/hermes/reportConfig/getSex',
    // '/hermes/reportConfig/getAge',
    // '/hermes/reportConfig/getPay',
    // '/hermes/reportConfig/getTime',
    // '/hermes/reportConfig/getFunnelData',
    // '/hermes/reportConfig/getFunnelChart',
    // '/hermes/reportConfig/deleteIndex',
    // '/hermes/reportConfig/deleteDimension',
    // '/hermes/reportConfig/addReport',
    // '/hermes/reportConfig/deleteReport',
    // '/hermes/reportConfig/offlineReport',
    // '/hermes/reportConfig/getDwTableName',
    // '/hermes/reportConfig/readTableContent',
    // '/hermes/reportConfig/getFilterContentList',
    // '/hermes/reportConfig/editReportName',
    // '/hermes/reportConfig/saveSummaryConfig',
    // '/hermes/reportConfig/saveFunnelConfig',
    // '/hermes/reportDetail/getFunnelConfig',
    // '/hermes/reportConfig/getFunnelChart',
    // '/hermes/reportDetail/getAttributeConfig',
    // '/hermes/reportDetail/getSummaryConfigList',
    // '/hermes/reportDetail/getSummaryTableData',
    // '/hermes/reportDetail/getIndexConfigList',
    // '/hermes/getAllUser',
    // '/hermes/template/getAllServices',
    // '/hermes/template/getAllTemplatesOfService',
    // '/hermes/template/saveBase',
    // '/hermes/template/getBase',
    // '/hermes/template/getInterfaceDoc',
    // '/hermes/template/saveInterfaceDoc',
    // '/hermes/template/getLogDoc',
    // '/hermes/template/saveLogDoc',
    // '/hermes/template/getSysTemConfig',
    // '/hermes/template/saveSysTemConfig',
    // '/hermes/template/getActivity',
    // '/hermes/template/getCardTypes'
    // '/hermes/template/getTest',
    // '/hermes/template/saveTest',
    // '/hermes/reportDetail/getIndexData',
    // '/hermes/template/getTest',
    // '/hermes/template/saveTest',
    // '/hermes/getAllProducts',
    // '/hermes/activity/getList',
    // '/hermes/reportConfig/saveReportOrder',
    // '/hermes/reportConfig/saveSmallCategoryOrder',
    // '/hermes/reportConfig/addSmallCategory',
    // '/hermes/reportConfig/deleteSmallCategory',
    // '/hermes/reportConfig/saveIndexConfig',
    // '/hermes/reportConfig/getAllRecommendGames',
    // '/hermes/reportConfig/getRecommendAndIndex',
    // '/hermes/reportConfig/getHistoryConfig',
    // '/hermes/reportConfig/saveAttributeConfig',
    // '/hermes/reportConfig/saveAttributeConfig',
    // '/hermes/crowd/queryCustomFeature',
    // '/hermes/crowd/queryPromeFeature',
    // '/hermes/delivery/getReviewerList',
    // '/hermes/activity/prePublish/selectReviewer',
    // '/hermes/activity/prePublish/selectReviewer',
    // '/hermes/activity/prePublish/getReviewer',
    // '/hermes/activity/prePublish/reviewerCheck'
    // '/hermes/interface/getDetail'
    // '/hermes/interface/save',
    // '/hermes/interface/getInterfaceList',
    // '/hermes/interface/delete'
    // '/hermes/interface/getDetail'
    // '/hermes/activity/prePublish/publishRecord'
    // '/hermes/activity/prePublish/testConfirmRecord'
    // '/hermes/activity_test/getTestListInfo',
    // '/hermes/activity_test/saveTestListInfo',
    // '/hermes/activity_test/getExceptionListInfo',
    // '/hermes/activity_test/saveExceptionListInfo',
    // '/hermes/activity_test/responseTest',
    // '/hermes/activity_test/getAllCrowds',
    // '/hermes/activity_test/getAllTriggers',
    // '/hermes/activity_test/singleTrigger_start',
    // '/hermes/activity_test/queryTasksStatus',
    // '/hermes/activity_test/singleTrigger_query',
    // '/hermes/activity_test/getPushRecord',
    // '/hermes/activity_test/resetPushRecord',
    // '/hermes/activity_test/getPushLimitRecord',
    // '/hermes/activity_test/setPushLimitRecord'
    // '/hermes/template/getServiceDocList',
    // '/hermes/activity/getActivityCards',
    // '/hermes/activity/getActivityModifyInfos'
    // '/hermes/template/getServiceDocList',
    // '/hermes/interview/getList',
    // '/hermes/interview/detail',
    // // '/hermes/template/autoGenerateId',
    // '/hermes/reportConfig/getRawSourceConfig',
    // '/hermes/reportConfig/getRawSourceTable',
    // '/hermes/reportConfig/saveRawSourceConfig'
    // '/hermes/delivery/getReviewList',
    // '/hermes/delivery/keywordList'
    // '/hermes/mailPush/birdList',
    // '/hermes/mailPush/getBirdInfo'
    // '/hermes/activity/abasExp/getExpSceneInfoList',
    // '/hermes/activity/abasExp/getExpSceneInfo',
    // '/hermes/activity/abasExp/getFatherExpInfoList',
    // '/hermes/activity/abasExp/getExpInfo'
    // '/hermes/activity/modifyAbExpType'
    // '/hermes/mailPush/getBirdInfo',
    // '/hermes/reportConfig/getRawSourceTable',
    // '/hermes/trigger/getDetail'.
    // '/hermes/activity/abasExp/getExpInfoByOpId',
    // '/hermes/widget/case/getGameTypeList',
    // '/hermes/widget/case/getVendorList',
    // '/hermes/widget/case/getWidgetList'
    // '/hermes/widget/metrics/getGameMetrics',
    // '/hermes/widget/metrics/getGameMetricsChart',
    // '/hermes/reportConfig/getReportList',
    // '/hermes/reportConfig/getClusterTableList',
    // '/hermes/reportConfig/getClusterConfig',
    // '/hermes/reportConfig/getClusterAnalysisTable',
    // '/hermes/reportDetail/getQuestionnaireList',
    // '/hermes/reportDetail/getClusterAnalysisConfigList',
    // '/hermes/reportDetail/getClusterAnalysisTable'
    // '/hermes/widget/metrics/getGameMetrics',
    // '/hermes/widget/metrics/getGameMetricsChart'
  ]
};
